import {NxCashMask} from '@nextbank/ui-components';
import React, {ReactNode} from 'react';

export const CashHelper = {

  addCurrency: (data: ReactNode): ReactNode => (<span>{data} PHP</span>),

  addCurrencyMask: (amount: number): ReactNode => CashHelper.addCurrency(<NxCashMask value={amount} decimals={2} />)
};
